import React, { useState, useEffect } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Skill,
  RollPlus,
  CharacterSheetInterface,
} from "@dndModels";

import LoadingBox from "@components/input/LoadingBox";

interface Props {
  char_int: CharacterSheetInterface;
  skill: Skill;
}

export default function CharacterSkillPDF({
  char_int,
  skill,
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bonuses_string, setBonusesString] = useState("");
  const [proficiency_multiplier, setProficiencyMultiplier] = useState(0);

  // eslint-disable-next-line
  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      load();
    }
  });

  const load = () => {
    setLoading(true);
    
    const char_roll_finder = char_int.skill_checks.filter(o => o.skill_id === skill._id);
    if (char_roll_finder.length === 1) {
      const char_roll = char_roll_finder[0].skill_check;
      const roll_plus = new RollPlus();
      roll_plus.flat = char_roll.modifier;
      let new_bonuses_string = "";
      let new_mod = char_roll.modifier;
      char_roll.rolls.forEach(bonus => {
        const roll_plus2 = bonus;
        if (roll_plus2) {
          new_mod += roll_plus2.flat;
          if (!["","None","undefined"].includes(roll_plus2.ability_score)) {
            const mod = char_int.current_ability_scores.getModifier(roll_plus2.ability_score);
            if (mod) {
              new_mod += mod;
            }
          }
          if (roll_plus2.size === 1) {
            new_mod += roll_plus2.count;
          } else if (roll_plus2.size > 1 && roll_plus2.count !== 0) {
            roll_plus2.recalculate_string();
            if (roll_plus2.as_string.length > 0 && roll_plus2.as_string[0] !== "-") {
              new_bonuses_string += `+${roll_plus2.as_string}`;
            } else {
              new_bonuses_string += roll_plus2.as_string;
            }
          }
        }
      });
      if (new_mod > 0) {
        new_bonuses_string = `+${new_mod}${new_bonuses_string}`;
      } else if (new_mod < 0) {
        new_bonuses_string = `${new_mod}${new_bonuses_string}`;
      } else if (new_bonuses_string === "") {
        new_bonuses_string = "+0";
      }
      setBonusesString(new_bonuses_string);
      setProficiencyMultiplier(char_roll.proficiency);
      setLoading(false);
    }
  }

  if (!fetched || loading) {
    return <LoadingBox />;
  } else {
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 2
          }}>
          <div className="centered" style={{ 
            lineHeight: "2.8", fontSize: "8px"
          }}>
            { proficiency_multiplier === 1 ? "P" : (proficiency_multiplier === 2 ? "E" : (proficiency_multiplier === 0.5 ? "H" : "")) }
          </div>
        </Grid>
        <Grid
          size={{
            xs: 1
          }}></Grid>
        <Grid
          size={{
            xs: 6
          }}>
          { skill.name.includes(" ") ? 
            <div style={{ float: "left", lineHeight: "3", fontSize: "6px" }}>
              { skill.name } 
            </div>
          :
            <div style={{ float: "left", lineHeight: "2.8", fontSize: "8px" }}>
              { skill.name } 
            </div>
          }
        </Grid>
        <Grid
          className="centered"
          style={{ lineHeight: "2" }}
          size={{
            xs: 3
          }}>
          {bonuses_string}
        </Grid>
      </Grid>
    );
  }
}
